import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-staroff",
  "use": "icon-staroff-usage",
  "viewBox": "0 0 24 22",
  "content": "<symbol viewBox=\"0 0 24 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-staroff\">\n<path d=\"M12 17.76L4.94701 21.708L6.52201 13.78L0.587006 8.292L8.61401 7.34L12 0L15.386 7.34L23.413 8.292L17.478 13.78L19.053 21.708L12 17.76ZM12 15.468L16.247 17.845L15.298 13.072L18.871 9.767L14.038 9.194L12 4.775L9.96201 9.195L5.12901 9.767L8.70201 13.072L7.75301 17.845L12 15.468Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/staroff.svg
// module id = PHuH
// module chunks = 111